import axios from "@/libs/api.request";
export const getB2bWarehouse = params => {
  return axios.request({
    url: "/common/b2bWarehouse",
    method: "GET",
    params
  });
};
export const getDetails = id => {
  return axios.request({
    url: `/common/b2bWarehouse/${id}`,
    method: "GET"
  });
};
export const del = id => {
  return axios.request({
    url: `/common/b2bWarehouse/${id}`,
    method: "DELETE"
  });
};
export const update = data => {
  return axios.request({
    url: `/common/b2bWarehouse/${data.id}`,
    method: "PUT",
    data
  });
};
export const add = data => {
  return axios.request({
    url: "/common/b2bWarehouse",
    method: "POST",
    data
  });
};

export const getB2bWarehouseConfig = params => {
  return axios.request({
    url: "/common/b2bWarehouse/config",
    method: "get",
    params
  });
};
